module.exports = __webpack_public_path__ + "static/whereIC-cd4a851f64b02246be414a2f5c6d79b1.jpg";